// @ts-nocheck
import React, { useState, useEffect, useReducer } from "react";
import {
  Box,
  Avatar,
  Typography,
  Button,
  Modal,
  Backdrop,
  TextField,
  Grid,
  CircularProgress,
} from "@mui/material";
import Icon from "@mui/material/Icon";
import InputMask from "react-input-mask";
import { get, post, put, patch } from "requests";

const modalStyle = {
  position: "absolute",
  top: "8%",
  left: "200px",
  width: 370,
  bgcolor: "background.paper",
  boxShadow: 3,
  p: 0,
  borderRadius: 2,
  border: "1px solid #ddd",
};

function ProfileCard({
  userId,
  tenantName,
  fullName,
  setFullName,
  open,
  onClose,
  alert,
  setAlert,
  setDialog,
}) {
  const [userDetails, setUserDetails] = useState<any>(null);
  const [initialData, setInitialData] = useState(null);
  const [emailError, setEmailError] = useState(false);

  const formReducer = (state, action) => {
    switch (action.type) {
      case "SET_ALL":
        return { ...state, ...action.payload };
      case "UPDATE_FIELD":
        const updatedState = { ...state, [action.field]: action.value };
        updatedState.fullName =
          `${updatedState.firstName} ${updatedState.middleName} ${updatedState.lastName}`.trim();
        return updatedState;
      default:
        return state;
    }
  };

  const [formData, dispatch] = useReducer(formReducer, {
    fullName: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!open || !userId) return;

      try {
        const response = await get(`/getUserProfileInfo/${userId}`);
        setUserDetails(response);

        const mappedData = {
          fullName: response.fullName || "",
          firstName: response.firstName || "",
          middleName: response.middleName || "",
          lastName: response.lastName || "",
          email: response.email || "",
          phoneNumber: response.phoneNumber || "",
        };

        setInitialData(mappedData);
        dispatch({ type: "SET_ALL", payload: mappedData });
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, [open, userId]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.trim().split(" ");
    return (
      (names[0]?.[0] || "") + (names.length > 1 ? names[names.length - 1]?.[0] || "" : "")
    ).toUpperCase();
  };

  const getRandomColor = (name: string): string => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 80%, 40%)`;
  };

  const formatLabel = (item) => {
    if (!item || !item.trim()) return "";
    return item
      .trim()
      .toLowerCase()
      .replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
  };

  const handleFieldChange = (field, value) => {
    dispatch({ type: "UPDATE_FIELD", field, value });
  };

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!regex.test(value));
    handleFieldChange("email", value);
  };

  const isFormModified =
    initialData &&
    JSON.stringify({ ...formData, fullName: undefined }) !==
      JSON.stringify({ ...initialData, fullName: undefined });

  const handleUpdate = async (e: any) => {
    e.preventDefault();

    if (emailError) {
      setAlert({
        type: "error",
        message: "Please enter a valid email.",
        timeOut: 5000,
      });
      return;
    }

    const user = {
      id: userId,
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      fullName: formData.fullName,
      email: formData.email,
      phoneNumber: formData.phone,
    };

    try {
      const res = await patch(`/users/${user.id}`, user, { baseURL: "/" });
      setFullName(user.fullName);
      localStorage.setItem("firstName", user.firstName);
      localStorage.setItem("middleName", user.middleName);
      localStorage.setItem("lastName", user.lastName);
      localStorage.setItem("fullName", user.fullName);
      localStorage.setItem("currentUserEmail", user.email);

      window.sideBar.setState({
        firstName: user.firstName,
        lastName: user.lastName,
      });

      if (
        (user.email && user.email !== initialData.email) ||
        initialData.password !== user.password
      ) {
        updateKeyCloakUser(user, initialData?.email, initialData?.password);
      }

      setAlert({
        type: "success",
        message: "Profile has been  updated.",
        timeOut: 4000,
      });

      onClose();
    } catch (err) {
      console.error("Error updating user:", err);
      setAlert({
        type: "error",
        message: "An error occurred while updating your profile.",
        timeOut: 5000,
      });
    }
  };

  const updateKeyCloakUser = async (user: any, originalEmail: string, password?: string) => {
    if (!user.id) return;

    const data: any = { userId: user.id };

    if (typeof password !== "undefined") {
      data.isPasswordChanged = password !== user.password;
    }

    data.isEmailChanged = originalEmail !== user.email;

    try {
      const response = await post(`updateKeyCloakUser`, data);
      if (response?.isEmailSent) {
        alert(`User credentials sent to \n${user.email}`);
      }
      console.log("Keycloak user updated successfully.");
    } catch (err) {
      console.error("Error updating Keycloak user:", err);
    }
  };

  function generateRandomPassword() {
    const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$&*";
    const length = Math.floor(Math.random() * 3) + 6;
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  }

  const updateKeyCloakPassword = async (userId: any) => {
    if (!userId) return;
    const newPassword = generateRandomPassword();
    const res = await patch(`/users/${userId}`, { password: newPassword }, { baseURL: "/" });
    const data: any = { userId: userId };
    data.isEmailChanged = false;
    data.isPasswordChanged = true;
    data.password = newPassword;

    try {
      const response = await post(`updateKeyCloakUser`, data);
      if (response?.isEmailSent) {
        onClose();
        setDialog(
          `Temporary credentials have been sent to:\n${initialData?.email} \n\n Would you like to begin resetting the password now?`
        );
      }
      console.log("Keycloak user updated successfully.");
    } catch (err) {
      console.error("Error updating Keycloak user:", err);
    }
  };

  if (!userDetails) {
    return (
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          <Box p={2} display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{ style: { backgroundColor: "transparent" } }}
    >
      <Box sx={modalStyle}>
        <Box sx={{ position: "relative", height: "200px" }}>
          <Box
            sx={{
              backgroundColor: "#2F929F",
              height: "50%",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <div className="profile-card-tinfo">{formData.fullName}</div>
          </Box>

          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              paddingBottom: "5px",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", alignItems: "start" }}
              className="profile-card-binfo"
            >
              <div style={{ padding: "0px 12px" }}>
                <div className="size-17">{formatLabel(localStorage.getItem("userRole"))}</div>
                <div style={{ fontSize: "12px", color: "#7B809A", fontWeight: "300px" }}>
                  {formatLabel(tenantName)}
                </div>
              </div>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  textTransform: "none",
                  color: "#4F4F52",
                  borderColor: "#4F4F52",
                  mt: 1,
                  width: "fit-content",
                  ":hover": { borderColor: "#4F4F52", color: "#4F4F52" },
                }}
                onClick={() => {
                  updateKeyCloakPassword(userId);
                }}
              >
                <Icon sx={{ mr: 0.5 }}>lock_reset</Icon>
                Update Password
              </Button>
            </div>
          </Box>

          <Avatar
            sx={{
              width: 100,
              height: 100,
              position: "absolute",
              top: "50%",
              left: "16px",
              transform: "translateY(-50%)",
              border: "2px solid white",
              backgroundColor: getRandomColor((formData?.fullName || "").split(" ")[0]),
              color: "white",
              fontSize: 36,
              fontWeight: 500,
            }}
          >
            {getInitials(formData?.fullName || "")}
          </Avatar>
        </Box>

        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="First Name"
                variant="standard"
                value={formData.firstName}
                onChange={(e) => handleFieldChange("firstName", e.target.value)}
                margin="dense"
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Middle Name"
                variant="standard"
                value={formData.middleName}
                onChange={(e) => handleFieldChange("middleName", e.target.value)}
                margin="dense"
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Last Name"
                variant="standard"
                value={formData.lastName}
                onChange={(e) => handleFieldChange("lastName", e.target.value)}
                margin="dense"
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                variant="standard"
                value={formData.email}
                error={emailError}
                helperText={emailError ? "Invalid email format" : ""}
                onChange={(e) => validateEmail(e.target.value)}
                margin="dense"
                InputProps={{ style: { color: "#3f8dbb" } }}
              />
            </Grid>

            <Grid item xs={6}>
              <InputMask
                mask="(999) 999-9999"
                value={formData.phone}
                onChange={(e) => handleFieldChange("phone", e.target.value)}
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    fullWidth
                    label="Phone"
                    variant="standard"
                    margin="dense"
                  />
                )}
              </InputMask>
            </Grid>
          </Grid>
        </Box>

        <Box display="flex" justifyContent="flex-end" gap={2} p={2}>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ textTransform: "none", backgroundColor: "#333" }}
            style={{ color: "white" }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{
              textTransform: "none",
              backgroundColor: "#2F929F",
              ":hover": { backgroundColor: "#2F929F" },
            }}
            style={{ color: "white" }}
            onClick={handleUpdate}
            disabled={!isFormModified || emailError}
          >
            Update
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default ProfileCard;
